// /help/auth - "What is a bunker?" page linked from the Login Modal.
//
// Per Vault/Runbook/Phase 1 - Shared Engine.md task 1.13a. Token-bound CSS
// (no inline colours) so the page matches light + dark themes.

export function renderHelpAuth(target: HTMLElement): void {
  target.innerHTML = '';
  const article = document.createElement('article');
  article.className = 'help-page';

  article.innerHTML = `
    <h1 class="help-title">Sign in with a bunker</h1>
    <p class="help-body">
      A <strong>bunker</strong> (NIP-46) is a remote Nostr signer - it holds your
      private key on another device (a separate app, phone, or service) so the
      website never sees your key. You scan a QR code (or paste a URI) once,
      then approve sign requests from your bunker app whenever a game asks
      to publish a share.
    </p>
    <h2 class="help-h2">Recommended</h2>
    <p class="help-body">
      <a class="help-link" href="https://clave.casa" rel="noopener">clave.casa</a>
      (web + iOS, easy onboarding).
    </p>
    <h2 class="help-h2">Alternatives</h2>
    <ul class="help-list">
      <li><a class="help-link" href="https://nsec.app" rel="noopener">nsec.app</a> (web)</li>
      <li>Amber (Android)</li>
    </ul>
    <h2 class="help-h2">What we ask for</h2>
    <p class="help-body">
      nostr.gives only ever asks for permissions to:
    </p>
    <ul class="help-list">
      <li>Read your public key</li>
      <li>Sign kind 1 notes (game shares)</li>
      <li>Sign kind 30078 events (optional cross-device streak backup)</li>
    </ul>
    <p class="help-body">Nothing else.</p>
    <p class="help-back"><a class="help-link" href="#/">Back to home</a></p>
  `;

  target.appendChild(article);
}
